<script setup lang="ts">
import type { AppButtonSize } from 'libs/ui/src/lib/components/appButton/AppButton.model';

import type { AppButtonType } from '@libs/ui';
import { AppButton } from '@libs/ui';

interface PaxSelectorButtonProps {
  buttonText: string;
  spaceBetween?: boolean;
  type?: AppButtonType;
  size?: AppButtonSize;
}

const props = withDefaults(defineProps<PaxSelectorButtonProps>(), {
  size: 'small',
  type: 'modern',
});

interface PaxSelectorButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<PaxSelectorButtonEmits>();
</script>

<template>
  <AppButton
    :type="props.type"
    state="enabled"
    :size="props.size"
    :left-icon="{
      size: '18',
      name: 'peopleOutlined',
    }"
    :right-icon="{
      size: '18',
      name: 'chevronDown',
    }"
    :space-between="props.spaceBetween"
    @click="emit('click')"
  >
    {{ props.buttonText }}
  </AppButton>
</template>
